export default {"src":"/_next/static/media/surfing.f10972f6.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};